import formStyles from "~/Screens/GeneralStyles/formStyle";

const useStyles = (theme) => ({
    ...formStyles(theme),
});


export default useStyles;